<template>
  <b-card id="page-membership-form" no-body class="mb-0">
    <b-card-header>
      <b-card-title>
        <h2>
          {{ $t(getTitle()) }}
          {{ $t("pages.membership.detailPayment") }}
        </h2>
      </b-card-title>
      <b-button variant="primary" @click="backButton">
        <feather-icon icon="ArrowLeftIcon" />
        {{ $t("back") }}
      </b-button>
    </b-card-header>
    <b-card-body>
      <validation-observer ref="paymentform">
        <b-form>
          <b-row>
            <!-- <b-col cols="12" sm="6" md="6" lg="6" xl="6" v-if="option == 3">
              <b-form-group :label="$t(label('company'))" label-for="company">
                <validation-provider
                  #default="{ errors }"
                  :name="$t(label('company'))"
                  rules="required"
                >
                  <b-form-input
                    id="company"
                    v-model="payment.company"
                    :disabled="!isSaveMode"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t(label('company'))"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col> -->

            <b-col cols="12" sm="6" md="6" lg="6" xl="6">
              <validation-provider
                #default="{ errors }"
                :name="$t(label('company'))"
                rules="required"
              >
                <b-form-group
                  :label="$t(label('company'))"
                  label-for="company"
                  :state="errors.length > 0 ? false : null"
                >
                  <v-select
                    v-model="payment.idSubscriptionCompany"
                    input-id="company"
                    :options="listCompanies"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="nameCompany"
                    :placeholder="$t(label('company'))"
                    :disabled="!isSaveMode"
                    :taggable="false"
                    :reduce="(option) => option.idSubscriptionCompany"
                    @search="searchCompaniesAll"
                    :filterable="false"
                    @open="onOpenCompanies"
                  >
                    <template #list-footer>
                      <li
                        v-show="hasNextPageCompanies"
                        ref="loadCompanies"
                        class="loader"
                      >
                        Cargando más opciones...
                      </li>
                    </template>
                  </v-select>
                  <b-form-invalid-feedback
                    :state="errors.length > 0 ? false : null"
                  >
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="12" sm="3" md="3" lg="3" xl="3">
              <b-form-group
                :label="$t(label('referenceNumber'))"
                label-for="referenceNumber"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t(label('referenceNumber'))"
                  rules="required"
                >
                  <b-form-input
                    id="referenceNumber"
                    v-model="payment.referenceNumber"
                    :disabled="!isSaveMode"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t(label('referenceNumber'))"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="12" sm="3" md="3" lg="3" xl="3">
              <b-form-group :label="$t(label('amount'))" label-for="amount">
                <validation-provider
                  #default="{ errors }"
                  :name="$t(label('amount'))"
                  rules="required"
                >
                  <b-form-input
                    id="amount"
                    v-model="payment.amount"
                    :disabled="!isSaveMode"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t(label('amount'))"
                    type="number"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="6" md="6" lg="6" xl="6" v-if="option == 3">
              <b-form-group
                :label="$t(label('typeSubscription'))"
                label-for="typeSubscription"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t(label('typeSubscription'))"
                  rules="required"
                >
                  <b-form-input
                    id="typeSubscription"
                    v-model="payment.typeSubscription"
                    :disabled="!isSaveMode"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="$t(label('typeSubscription'))"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col cols="12" sm="6" md="6" lg="6" xl="6" v-if="option == 3">
              <validation-provider
                #default="{ errors }"
                :name="$t(label('descriptionSubscription'))"
                rules="required"
              >
                <b-form-group
                  :label="$t(label('descriptionSubscription'))"
                  label-for="descriptionSubscription"
                >
                  <b-form-textarea
                    id="descriptionSubscription"
                    v-model="payment.descriptionSubscription"
                    :placeholder="$t(label('descriptionSubscription'))"
                    :disabled="!isSaveMode"
                    :state="errors.length > 0 ? false : null"
                    rows="3"
                  />
                </b-form-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>

            <b-col cols="12" sm="6" md="6" lg="6" xl="6">
              <validation-provider
                #default="{ errors }"
                :name="$t(label('typePayment'))"
                rules="required"
              >
                <b-form-group
                  :label="$t(label('typePayment'))"
                  label-for="typePayment"
                  :state="errors.length > 0 ? false : null"
                >
                  <v-select
                    v-model="payment.idCatPaymentType"
                    input-id="typePayment"
                    ref="typePayment"
                    :options="listTypePayments"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    :placeholder="$t(label('typePayment'))"
                    :disabled="!isSaveMode"
                    :reduce="(option) => option.id"
                  >
                  </v-select>
                  <b-form-invalid-feedback
                    :state="errors.length > 0 ? false : null"
                  >
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="12" sm="6" md="6" lg="6" xl="6" v-if="option == 3">
              <validation-provider
                #default="{ errors }"
                :name="$t(label('status'))"
                rules="required"
              >
                <b-form-group
                  :label="$t(label('status'))"
                  label-for="status"
                  :state="errors.length > 0 ? false : null"
                >
                  <v-select
                    v-model="payment.idCatStatus"
                    input-id="status"
                    ref="status"
                    :options="listSubscriptionStatus"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="name"
                    :placeholder="$t(label('status'))"
                    :disabled="!isSaveMode"
                    :reduce="(option) => option.id"
                  >
                  </v-select>
                  <b-form-invalid-feedback
                    :state="errors.length > 0 ? false : null"
                  >
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
            <b-col cols="12" sm="6" md="6" lg="6" xl="6">
              <b-form-group
                :label="$t(label('startDate'))"
                label-for="startDate"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t(label('startDate'))"
                  rules="required"
                >
                  <b-form-datepicker
                    id="startDate"
                    ref="startDate"
                    v-model="payment.date"
                    :placeholder="$t(label('startDate'))"
                    :state="errors.length > 0 ? false : null"
                    :disabled="!isSaveMode"
                    class="mr-2"
                    reset-button
                    dropright
                    :min="new Date()"
                  >
                  </b-form-datepicker>

                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col
              cols="12"
              sm="6"
              md="6"
              lg="6"
              xl="6"
              class="d-flex align-items-center justify-content-center"
            >
              <b-form-group
                :label="$t(label('flayer'))"
                label-for="inputFilePhoto"
              >
                <b-media class="body-style">
                  <div v-if="!payment.urlProofOfPayment">
                    <input
                      id="inputFilePhoto"
                      ref="fileInputPhoto"
                      name="inputFilePhoto"
                      type="file"
                      class="hidden"
                      accept=".png,.peg,.jpg,.jpeg"
                      @change="onFileChange($event, 'urlProofOfPayment')"
                    />
                    <div
                      class="cursor-pointer m-auto cuve text-center border-2 d-flex align-items-center justify-content-center"
                      accept=".png,.peg,.jpg,.jpeg"
                      @drop="handleDrop($event, 'urlProofOfPayment')"
                      @dragover="handleDragover"
                      @dragenter="handleDragover"
                      @click="$refs.fileInputPhoto.click()"
                    >
                      <feather-icon
                        icon="UploadCloudIcon"
                        size="20"
                        svg-classes="h-16 w-16 stroke-current text-grey"
                      />
                      <span
                        style="margin-left: 5px"
                        @click.stop="$refs.fileInputPhoto.click()"
                        >{{ $t(label("flayer")) }}
                      </span>
                    </div>
                  </div>
                  <template v-if="payment.urlProofOfPayment" #aside>
                    <img
                      id="image"
                      ref="image"
                      :src="payment.urlProofOfPayment"
                      class="img-avatar border-dashed"
                    />
                  </template>
                </b-media>
              </b-form-group>
            </b-col>
            <b-col
              class="d-flex justify-content-end align-items-center"
              cols="12"
            >
              <b-button
                v-if="option == 1"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="primary"
                class="mr-1"
                @click.prevent="onSubmit"
              >
                {{ $t("save") }}
              </b-button>
              <b-button
                v-if="option == 1"
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="reset"
                variant="outline-secondary"
                @click="onCancel"
              >
                {{ $t("cancel") }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card-body>
  </b-card>
</template>

<script>
import _ from "lodash";

import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import {
  BInputGroup,
  BCard,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BFormGroup,
  BFormCheckbox,
  BForm,
  BFormTextarea,
  BToast,
  BMedia,
  BFormInvalidFeedback,
  BFormDatepicker,
  BFormTimepicker,
} from "bootstrap-vue";
import router from "@/router";
import Ripple from "vue-ripple-directive";
import { showLoading, stopLoading, getParams } from "@core/utils/utils";
import { required, integer } from "@validations";
import vSelect from "vue-select";
import { getCatalog } from "@core/api/request/catalogs";
import { postFile } from "@core/api/request/catalogs";
import { VueTelInput } from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";

import {
  createOrEditPromotions,
  getPromotion,
} from "@core/api/request/promotions";
import {
  getPayment,
  allCompanyMemberships,
  registerPaymentSubcription,
} from "@/@core/api/request/membership";
import flatPickr from "vue-flatpickr-component";
import moment from "moment";

const payment = {
  company: null,
  typeSubscription: null,
  descriptionSubscription: null,
  date: null,
  amount: null,
  idCatPaymentType: null,
  idCatStatus: null,
  urlProofOfPayment: null,
  referenceNumber: null,
  idSubscriptionCompany: null,
};
export default {
  components: {
    BInputGroup,
    ValidationProvider,
    ValidationObserver,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    vSelect,
    BFormTextarea,
    BToast,
    BFormInvalidFeedback,
    BMedia,
    BFormDatepicker,
    BFormTimepicker,
    VueTelInput,
    flatPickr,
  },

  directives: {
    Ripple,
  },
  data() {
    return {
      isSaveMode: true,
      companyGuid: null,
      required,
      integer,
      payment: Object.assign(payment),
      option: "",
      idSubscriptionPayment: null,
      listSubscriptionStatus: [],
      loading: false,
      listTypePayments: [],
      currentPageCompanies: 1,
      perPageComapanies: 20,
      totalPagesCompanies: null,
      observerCompanies: null,
      hasNextPageCompanies: true,
      loadingPayment: false,
      listCompanies: [],
    };
  },
  created() {
    localize("es");
  },
  computed: {},
  mounted() {
    this.payment = {
      company: null,
      typeSubscription: null,
      descriptionSubscription: null,
      date: null,
      amount: null,
      idCatPaymentType: null,
      idCatStatus: null,
      urlProofOfPayment: null,
      referenceNumber: null,
      idSubscriptionCompany: null,
    };
    this.companyGuid = this.$store.state.appConfig.activeCompanyGuid;
    this.initialize();
    const observers = [
      { name: "companies", callback: this.infiniteScrollCompanies },
    ];

    observers.forEach((observer) => {
      this[
        `observer${
          observer.name.charAt(0).toUpperCase() + observer.name.slice(1)
        }`
      ] = new IntersectionObserver(observer.callback);
    });
  },
  watch: {
    "$store.state.appConfig.activeCompanyGuid"(guid) {
      this.companyGuid = guid;
    },
  },
  methods: {
    backButton() {
      this.onCancel();
      this.goBack();
    },

    deleteFile(field) {
      this.promotion[field] = null;
    },

    handleDragover(e) {
      e.stopPropagation();
      e.preventDefault();
      e.dataTransfer.dropEffect = "copy";
    },

    onFileChange(e, field) {
      if (e?.target?.files?.length > 0) {
        this.onTransFile(
          e?.target?.files,
          e.target.accept,
          e.target.multiple,
          field,
        );
      }
    },

    onTransFile(files, accept, multiple, field) {
      if (multiple) return;
      this.loadingPhoto = true;
      files.forEach((file) => {
        if (!file) return;
        const type = file.type.split("/").pop();
        const isPdf = type === "pdf";
        const isImage = ["jpeg", "jpg", "png"].includes(type);
        if (!isPdf && !isImage) return;
        showLoading();
        postFile(file)
          .then((resp) => {
            this.payment[field] = resp.data;
          })
          .catch(console.error)
          .finally(() => {
            this.loadingPhoto = false;
            stopLoading();
          });
      });
    },

    resetData() {
      this.payment = {
        company: null,
        typeSubscription: null,
        descriptionSubscription: null,
        date: null,
        amount: null,
        idCatPaymentType: null,
        idCatStatus: null,
        urlProofOfPayment: null,
        referenceNumber: null,
        idSubscriptionCompany: null,
      };
      this.hasNextPageCompanies = true;
    },

    async loadData() {
      await Promise.all([
        this.getSubscriptionsTypePayments(),
        this.getSubscriptionsStatus(),
        this.loadCompaniesSubscriptions(),
      ]);
    },
    label(field) {
      return `pages.membership.form.label.${field}`;
    },
    getTitle() {
      if (this.option === 1) return "register";
      else if (this.option === 2) return "show";
      else if (this.option === 3) return "edit";
    },
    getSubscriptionsTypePayments() {
      const arrParams = getParams([
        `itemsPage,1`,
        `itemsRows,999`,
        `guidCatalog,68cafe23-6c26-4724-88a4-47033e442034`,
      ]);
      getCatalog(arrParams)
        .then((resp) => {
          stopLoading();
          const data = _.get(resp, "data") || [];
          this.listTypePayments = data.listOfItems.items;
        })
        .catch((error) => {
          stopLoading();
          this.alertToast("danger", error.message);
        });
    },

    getSubscriptionsStatus() {
      const arrParams = getParams([
        `itemsPage,1`,
        `itemsRows,999`,
        `guidCatalog,2374e0f0-d8be-4cff-b42c-6bea9ecd9fb4`,
      ]);
      getCatalog(arrParams)
        .then((resp) => {
          stopLoading();
          const data = _.get(resp, "data") || [];
          this.listSubscriptionStatus = data.listOfItems.items;
        })
        .catch((error) => {
          stopLoading();
          this.alertToast("danger", error.message);
        });
    },
    async initialize() {
      this.idSubscriptionPayment = this.$route.params.idSubscriptionPayment;
      this.option = this.$route.params.option;
      if (this.idSubscriptionPayment === undefined) {
        router.push({ name: "AdminPaymentHistories" }).catch(() => {});
      }
      await this.loadData();
      switch (this.option) {
        case 1:
          this.onCancel();
          break;
        // option 2 to show, option 3 to edit
        case 2:
          if (this.$route.params.idSubscriptionPayment === undefined) {
            router.push({ name: "AdminPaymentHistories" }).catch(() => {});
          }
          this.isSaveMode = false;
          await this.getPaymentById(this.idSubscriptionPayment);

          break;
        case 3:
          if (this.$route.params.idSubscriptionPayment === undefined) {
            router.push({ name: "AdminPaymentHistories" }).catch(() => {});
          }

          this.isSaveMode = false;
          await this.getPaymentById(this.idSubscriptionPayment);
          // await this.showPromotion(this.$route.params.idPromotion);
          break;
      }
    },
    async getPaymentById(paymentId) {
      if (this.loadingPayment) return;

      this.loadingPayment = true;
      await getPayment(paymentId)
        .then((resp) => {
          const data = _.get(resp, "data");
          if (data != null) {
            this.payment = Object.assign({
              company: data?.company?.nam,
              typeSubscription: data?.subscription?.name,
              descriptionSubscription: data?.subscription?.description,
              date: data?.date,
              amount: data?.amount,
              idCatPaymentType: data?.idCatPaymentType,
              idCatStatus: data?.idCatStatus,
              urlProofOfPayment: data?.urlProofOfPayment,
              referenceNumber: data?.referenceNumber,
              idSubscriptionCompany: data?.idSubscriptionCompany,
            });
          }
        })
        .catch((error) => {
          console.log("error", error);
        })
        .finally(() => {
          this.loadingPayment = false;
        });
    },
    async onOpenCompanies() {
      if (this.hasNextPageCompanies) {
        await this.$nextTick();
        this.observerCompanies.observe(this.$refs.loadCompanies);
      }
    },
    async searchCompaniesAll(value) {
      this.listCompanies = [];
      this.currentPageCompanies = 1;
      this.hasNextPageCompanies = true;
      this.loadCompaniesSubscriptions();
    },
    onSubmit() {
      this.$refs.paymentform.validate().then((success) => {
        if (success) {
          // showLoading();

          const data = {
            idSubscriptionCompany: this.payment.idSubscriptionCompany,
            date: new Date(this.payment.date).toISOString(),
            amount: this.payment.amount,
            idCatPaymentType: this.payment.idCatPaymentType,
            urlProofOfPayment: this.payment.urlProofOfPayment,
            referenceNumber: this.payment.referenceNumber,
          };

          registerPaymentSubcription(data)
            .then((resp) => {
              stopLoading();
              if (resp.data.err) {
                this.alertToast("danger", `${resp.data.message}`);
                return;
              }
              this.alertToast("success", `${resp.data.message}`);
              this.goBack();
            })
            .catch((error) => {
              stopLoading();
              this.alertToast("danger", "Error", error.message);
              stopLoading();
            });
        }
      });
    },
    onCancel() {
      this.payment = Object.assign({
        company: null,
        typeSubscription: null,
        descriptionSubscription: null,
        date: null,
        amount: null,
        idCatPaymentType: null,
        urlProofOfPayment: null,
        referenceNumber: null,
        idCatStatus: null,
      });
    },
    alertToast(type = null, title = null, message = null) {
      this.$bvToast.toast(message, {
        title,
        variant: type,
        solid: true,
        icon: "CoffeeIcon",
      });
    },
    goBack() {
      this.$refs.paymentform.reset();
      router.back();
    },
    deleteFile(field) {
      this.company[field] = null;
    },
    handleDragover(e) {
      e.stopPropagation();
      e.preventDefault();
      e.dataTransfer.dropEffect = "copy";
    },
    onFileChange(e, field) {
      if (e?.target?.files?.length > 0) {
        this.onTransFile(
          e?.target?.files,
          e.target.accept,
          e.target.multiple,
          field,
        );
      }
    },
    onTransFile(files, accept, multiple, field) {
      if (multiple) return;
      // this.loadingPhoto = true
      files.forEach((file) => {
        if (!file) return;
        const type = file.type.split("/").pop();
        const isPdf = type === "pdf";
        const isImage = ["jpeg", "jpg", "png"].includes(type);
        if (!isPdf && !isImage) return;
        showLoading();
        postFile(file)
          .then((resp) => {
            this.payment[field] = resp.data;
          })
          .catch(console.error)
          .finally(() => {
            stopLoading();
          });
      });
    },
    async infiniteScrollCompanies(values) {
      const value = values[0];

      if (value.isIntersecting) {
        this.currentPageCompanies++;
        await this.loadCompaniesSubscriptions();
      }
    },
    chargeParamsByAdmin() {
      const arrParams = [];

      arrParams.push(`page,${this.currentPageCompanies}`);

      arrParams.push(`rows,${this.perPageComapanies}`);
      // if (
      //   this.companyGuid != null &&
      //   this.companyGuid.trim() !== "" &&
      //   this.companyGuid != "null"
      // )
      //   arrParams.push(`guidCompany,${this.companyGuid}`);

      return getParams(arrParams);
    },
    async loadCompaniesSubscriptions() {
      this.loading = !this.loading;
      if (!this.hasNextPageCompanies) return;
      const param = this.chargeParamsByAdmin();
      await allCompanyMemberships(param)
        .then((resp) => {
          const data = _.get(resp, "data");
          this.listCompanies = [...this.listCompanies, ...data?.items];
          this.loading = !this.loading;
          this.currentPageCompanies = data?.currentPage;
          this.totalPagesCompanies = data?.totalPages || 0;
          this.hasNextPageCompanies =
            this.currentPageCompanies < this.totalPagesCompanies;
        })
        .catch((error) => {
          console.log("error", error);
          this.loading = !this.loading;
          this.hasNextPageCompanies = false;
          this.alertToast("danger", `Alerta codigo`, error.message);
        });
    },
  },
};
</script>

<style lang="scss">
.img-avatar {
  height: auto !important;
}
</style>
